// Auth admin: clave compartida en sessionStorage. Vive solo mientras la
// pestana esta abierta — al cerrar se pierde y hay que volver a logearse.

const STORAGE_KEY = 'admin_password';

export function getStoredAdminPassword() {
    try { return window.sessionStorage.getItem(STORAGE_KEY) || ''; }
    catch { return ''; }
}

export function setStoredAdminPassword(pwd) {
    try { window.sessionStorage.setItem(STORAGE_KEY, pwd || ''); } catch {}
}

export function clearStoredAdminPassword() {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch {}
}

export function adminAuthHeaders() {
    const pwd = getStoredAdminPassword();
    return pwd ? { 'x-admin-password': pwd } : {};
}
